import script from "./SummaryItemIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryItemIcon.vue?vue&type=script&setup=true&lang=js"

import "./SummaryItemIcon.vue?vue&type=style&index=0&id=07f0ed56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f0ed56"]])

export default __exports__